/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Desktop(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,40H48A24.0275,24.0275,0,0,0,24,64V176a24.0275,24.0275,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24.0275,24.0275,0,0,0,24-24V64A24.0275,24.0275,0,0,0,208,40Zm0,144H48a8.00917,8.00917,0,0,1-8-8V160H216v16A8.00917,8.00917,0,0,1,208,184Z" />
    </Svg>
  );
}

export default Desktop;
